import axios from "axios";
import { serviceBaseUrl } from "./constants";
import { toast } from "react-toastify";

export const uploadFile = async (file: any) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axios.post(`${serviceBaseUrl}/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("File uploaded successfully.");
    return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
    return {
      code: 999,
      message: "Unable to upload the file.",
      result: null,
    };
  }
};
